'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _ListItemSecondaryAction = require('@material-ui/core/ListItemSecondaryAction');

var _ListItemSecondaryAction2 = _interopRequireDefault(_ListItemSecondaryAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        root: {}
    };
};

/**
 * A simple wrapper component to apply secondary action styles to ListItems.
 */
var ListItemSecondaryAction = function ListItemSecondaryAction(props) {
    var classes = props.classes,
        rest = _objectWithoutProperties(props, ['classes']);

    var classOverrides = {
        // See Material UI documentation for available CSS classes can be passed through to override
        root: classes.root
    };

    return _react2.default.createElement(_ListItemSecondaryAction2.default, Object.assign({}, rest, {
        classes: classOverrides
    }));
};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

ListItemSecondaryAction.propTypes = {
    /**
     * The content of the component, normally an `IconButton` or selection control.
     */
    children: _propTypes2.default.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object
};

// If default props are needed, they must be set here
// ListItemSecondaryAction.defaultProps = { };

exports.default = (0, _styles2.default)(styles)(ListItemSecondaryAction);